import { createAsyncThunk } from '@reduxjs/toolkit';
import { eaptekaApiRequestCartGet } from '../../services/eaptekaApi';
import { Optional } from '../../shared-kernel';
import { ProductWithAnalytics } from '../products/types';
import { Promocode } from '../promocode/types';
import { Summary } from '../summary/types';
import { ProductEntity } from '../types';

export type Cart = {
  products: ProductEntity<ProductWithAnalytics> | object;
  promocode: Optional<Promocode>;
  summary: Summary;
};

export const fetchCart = createAsyncThunk<Cart>(
  'cartPage/fetchCart',
  async (_, thunkApi) => {
    try {
      return await eaptekaApiRequestCartGet();
    } catch (error) {
      throw thunkApi.rejectWithValue({
        message: error.message
      });
    }
  }
);
